<template>
  <div class="container-fluid p-0 mx-0 mt-5 mb-0">
    <div class="row m-auto comfort">
      <div class="col p-0 image">
        <div data-aos="fade-right">
        <img src="../../assets/img/home_slide_1.png" />
      </div>
      </div>
      <div class="col p-0 product">
        <h1 class="sleep pt-5 pl-5">
          Relax in
          <br />Comfortable
        </h1>
        <p class="serene mt-4 pl-5">
          A wonderful serenity has taken possession of my entire soul, like these
          <br />sweet mornings of spring which I enjoy with my whole heart. I am
          <br />alone, and feel the.
        </p>
        <a href="#" class="buy mt-5 pl-5 mb-0">BUY THIS PRODUCT</a>
        <div class="line ml-5 mb-5"></div>
      </div>
      <div class="w-100"></div>
      <div class="col p-0 product">
        <h1 class="sleep pt-5 pl-5">
          Explore in
          <br />Style
        </h1>
        <p class="serene mt-4 pl-5">
          A wonderful serenity has taken possession of my entire soul, like these
          <br />sweet mornings of spring which I enjoy with my whole heart. I am
          <br />alone, and feel the.
        </p>
        <p class="buy mt-5 pl-5 mb-0">BUY THIS PRODUCT</p>
        <div class="line ml-5 mb-5"></div>
      </div>
      <div class="col p-0 image">
        <div data-aos="fade-left">
          <img src="../../assets/img/cat_img3@2x.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/page1/relax.vue